// These are the events to segment
export interface TSegmentTrackProps {
  eventName: string
  payload?: Record<string, unknown>
}
export function track({ eventName, payload }: TSegmentTrackProps) {
  const event = `${eventName}`.replace(/ /g, '_')

  if (process.env.NODE_ENV === 'development') {
    console.info({ event, payload })
    return
  }
  if (window.Android?.trackEvent) {
    window.Android.trackEvent(
      JSON.stringify({
        event_name: event,
        event_Param: payload,
      }),
    )
  } else if (window.webkit?.messageHandlers?.trackEvent?.postMessage) {
    window.webkit.messageHandlers.trackEvent.postMessage({
      event_name: event,
      event_Param: payload,
    })
  }
  if (window.Android?.track) {
    window.Android.track(
      JSON.stringify({
        event_name: event,
        event_Param: payload,
      }),
    )
  } else if (window.webkit?.messageHandlers?.track?.postMessage) {
    window.webkit.messageHandlers.track.postMessage({
      event_name: event,
      event_Param: payload,
    })
  } else if (
    window.analytics?.track &&
    typeof window.analytics.track === 'function'
  ) {
    window.analytics.track(event, payload)
  }
}

export interface TSegmentPageviewProps {
  pageName: string
  customData?: Record<string | number, unknown>
}
export function pageView({ pageName, customData }: TSegmentPageviewProps) {
  if (process.env.NODE_ENV === 'development') {
    console.info({ pageName })
    return
  }

  if (window.analytics && typeof window.analytics.page === 'function') {
    if (customData) {
      window.analytics.page(pageName, customData)
    } else {
      window.analytics.page(pageName)
    }
  }
}
